import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Division } from '../../../models/division';
import { Area } from '../../../models/area';
import { AlertaService } from '../../../services/alerta.service';
import { BenefitGroup } from '../../../models/benefit-group';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { findBenefitGroupAct, resetBenefitGroupAct, saveBenefitGroupAct, updateBenefitGroupAct } from '../../../store/benefit-group/benefit-group.action';
import { ActivatedRoute } from '@angular/router';
import { findAreasCatalogAct, findBenefitsCatalogAct, findDivisionsCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { BenefitConfiguration } from '../../../models/benefit-configuration';
import { Benefit } from '../../../models/benefit';

@Component({
  selector: 'app-benefits-edit',
  standalone: false,
  templateUrl: './benefits-edit.component.html',
  styleUrl: './benefits-edit.component.css'
})
export class BenefitsEditComponent {

  benefitGroupForm!: NgForm;
  benefitGroup: BenefitGroup = new BenefitGroup();
  loading: boolean = false;
  violations: any;
  divisions: Division[] = [];
  areas: Area[] = [];
  benefits: Benefit[] = [];
  private alerta = inject(AlertaService);
  
  ngOnInit(): void {
    this.benefitGroupStore.dispatch(resetBenefitGroupAct());
    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.benefitGroupStore.dispatch(findBenefitGroupAct({ id }));
      }else{
        this.benefitGroup = new BenefitGroup();
        //this.benefitGroup.active = true;
        this.loading = false;
      }
    });

    this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
    this.catalogOfferStore.dispatch(findAreasCatalogAct());
    this.catalogOfferStore.dispatch(findBenefitsCatalogAct());

  }
  constructor(
    private benefitGroupStore: Store<{benefitGroupRdc: any}>,
    private catalogOfferStore: Store<{catalogOfferRdc: any}>,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ){
    this.benefitGroup = new BenefitGroup();

    this.benefitGroupStore.pipe(
      select('benefitGroupRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        benefitGroup: state.benefitGroup,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ benefitGroup, violations, loading }) => {
      this.violations = violations;
      this.benefitGroup = JSON.parse(JSON.stringify(benefitGroup));
      // Ordenar lista de vacaciones 
      this.benefitGroup.benefitConfigurations.sort((a, b) =>  a.benefit.description.localeCompare(b.benefit.description, 'es', { sensitivity: 'base' }) );
      /*this.benefitGroup.benefitConfigurations.forEach(benefitConfiguration => {
        benefitConfiguration.sort((a, b) => a.initialYear - b.initialYear);
      });*/
      this.loading = loading;
      this.cd.markForCheck(); // fuerza la actualización de la vista

      if(this.benefitGroupForm){
        Object.keys(this.benefitGroupForm.controls).forEach(controlName => {
          const control = this.benefitGroupForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }
    });

    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        divisions: state.divisions,
        areas: state.areas,
        benefits: state.benefits
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ divisions, areas, benefits }) => {
      this.divisions = divisions;
      this.areas = areas;
      this.benefits = benefits;
    });
    
  }

  onSubmitBenefitGroup(benefitGroupForm: NgForm): void {
    this.loading = true;
    this.benefitGroupForm = benefitGroupForm;
    const benefitGroupCopy = JSON.parse(JSON.stringify(this.benefitGroup));

    if (benefitGroupCopy.id > 0) {
      this.benefitGroupStore.dispatch(updateBenefitGroupAct({ benefitGroupUpdated: benefitGroupCopy }))
    } else {
      this.benefitGroupStore.dispatch(saveBenefitGroupAct({ benefitGroupNew: benefitGroupCopy }))
    }
  }
 
  addBenefitConf(){
    const newBenefitConfigurations = new BenefitConfiguration();
    this.benefitGroup.benefitConfigurations = [...this.benefitGroup.benefitConfigurations, newBenefitConfigurations ];
  }

    hoveredRow: number | null = null;
    hoveredCol: number | null = null;

    isSelected(listIndex: number, divisionId: number, areaId: number): boolean {
      const list = this.benefitGroup.benefitConfigurations?.[listIndex];
      return list?.benefitDivisionAreaList.some(d =>
        d.id.divisionId === divisionId && d.id.areaId === areaId
      ) ?? false;
    }

    onCheckboxChange(listIndex: number, division: Division, area: Area, event: any): void {
      const checked = event.target.checked;
      const list = this.benefitGroup.benefitConfigurations?.[listIndex];
      if (!list) return;
    
      const index = list.benefitDivisionAreaList.findIndex(d =>
        d.id.divisionId === division.id && d.id.areaId === area.id
      );
    
      if (checked && index === -1) {
        // Agrega nuevo vínculo
        list.benefitDivisionAreaList.push({
          id: {
            holidayListId: list.id,
            divisionId: division.id,
            areaId: area.id
          },
          division,
          area
        });
      } else if (!checked && index !== -1) {
        // Elimina vínculo
        list.benefitDivisionAreaList.splice(index, 1);
      }
    }
    onMouseEnter(row: number, col: number) {
      this.hoveredRow = row;
      this.hoveredCol = col;
    }
  
    onMouseLeave() {
      this.hoveredRow = null;
      this.hoveredCol = null;
    }

    compareBenefit = (a: any, b: any) => a?.id === b?.id;
}
